import { Component, OnInit } from '@angular/core';
import { LeaveService } from 'src/app/providers/leave/leave.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';

@Component({
  selector: 'app-leave-approval',
  templateUrl: './leave-approval.component.html',
  styleUrls: ['./leave-approval.component.scss'],
})
export class LeaveApprovalComponent implements OnInit {
  leavesData: any = [];
  public page = 1;
  public count = 0;
  public pageSize = 10;
  public from;
  public to;
  loadingBulkApprove = false;
  constructor(
    private leaveServe: LeaveService,
    private notifyService: NotificationService
  ) {}

  ngOnInit(): void {
    this.LeaveRegister();
  }

  checkUncheckAllLeave(event): void {
    console.log(event.target.checked);
    const checked = event.target.checked;
    this.leavesData.forEach((item) => (item.isSelected = checked));
  }

  LeaveRegister(): void {
    this.leaveServe
      .EmpLeaveRegister({
        forms: { is_approved: 0 },
        pageIndex: this.page,
        limit: this.pageSize,
      })
      .subscribe((res) => {
        if (res.status) {
          this.leavesData = res.data.data;
          this.count = res.data.total;
          this.from = res.data.from;
          this.to = res.data.to;
        } else {
          this.notifyService.showInfo(res.msg, 'Info!');
        }
      });
  }

  bulkApproval(): void {
    console.log(this.leavesData);
    let data = [];
    data = this.leavesData.filter((res) => res.isSelected === true);

    if (data.length === 0) {
      alert('Please select at lease one leave');
      return;
    } else {
      console.log(data);
      this.loadingBulkApprove = true;
      this.leaveServe.builkApproveLeave(data).subscribe((res) => {
        if (res.status) {
          data = [];
          this.notifyService.showSuccess(res.msg, 'Approved');
          this.leavesData.forEach((item) => (item.isSelected = false));
          this.LeaveRegister();
          return false;
        }
        this.loadingBulkApprove = false;
        this.notifyService.showError(res.msg, 'Approved');
        return;
      });
    } // end of else
  }


  approveRej(data, AR): void {
    console.log(data, AR);
    if (AR === 1) {
      this.leaveServe
        .approveLeave({ leave_id: data.lv_id })
        .subscribe((res) => {
          if (res.status) {
            this.notifyService.showSuccess(res.msg, 'Approved');
            data.trans.forEach((el) => {
              if (el.color === '') {
                el.color = 'primary';
              }
            });
            data.pending = 0;
            data.approved = data.trans.length;
            return false;
          }
          this.notifyService.showError(res.msg, 'Approved');
          return false;
        });
    } else if (AR === 2) {
      this.leaveServe.rejectLeave({ leave_id: data.lv_id }).subscribe((res) => {
        if (res.status) {
          data.trans.forEach((el) => {
            if (el.color === '') {
              el.color = 'warn';
            }
          });
          data.pending = 0;
          data.rejected = data.trans.length;
          this.notifyService.showSuccess(res.msg, 'Rejected');
          return false;
        }
        this.notifyService.showError(res.msg, 'Rejected');
        return false;
      });
    }
    else if (AR === 3) {
      // approved reject
      this.leaveServe.rejectLeave({ leave_id: data.lv_id, both_is_approved: 'both_is_approved' }).subscribe((res) => {
        if (res.status) {
          data.trans.forEach(el => {
            if (el.color === '') {
              el.color = 'warn';
            }
          });
          data.pending = 0;
          data.approved = 0;
          data.rejected = data.trans.length;
          this.notifyService.showSuccess(res.msg, 'Rejected');
          return false;
        }
        this.notifyService.showError(res.msg, 'Rejected');
        return false;
      });
    }
    // $(modalID).modal({ backdrop: 'static', keyboard: false });
  }
}
